import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class AppDataService {

    pickupLocations: AngularFirestoreCollection<any>;

	constructor(
        private afs: AngularFirestore
    ) {}

    getPickupLocations() {
        return this.pickupLocations = this.afs.collection('pickuplocations', ref => ref.orderBy('location'));
    }

    getServiceableZipcode(zipcode) {
        return this.afs.doc(`serviceable_zipcodes/${zipcode}`).ref.get();
    }

    getPricingData() {
        
    }
    
}
